const ADD_ALERT = "jangl/alerts/ADD_ALERT";
const REMOVE_ALERT = "jangl/alerts/REMOVE_ALERT";
const REMOVE_ALL_ALERT = "jangl/alerts/REMOVE_ALL_ALERT";

export { ADD_ALERT, REMOVE_ALERT, REMOVE_ALL_ALERT };
